import { toast } from "sonner";
import { useMutation } from "@tanstack/react-query";
import { queryClient } from "utils/react-query.js";
import { createBookmark } from "./api";

function buildPayload(values, bookmark_folder) {
    if (!values || typeof values !== "object") return {};

    const { label, url, description } = values;

    return {
        label,
        url,
        description,
        bookmark: bookmark_folder,
    };
}

export const useCreateBookmark = ({ bookmark_folder }) => {
    return useMutation({
        mutationFn: async ({ values }) => {
            const payload = buildPayload(values, bookmark_folder);
            const response = await createBookmark(payload);
            return response;
        },
        onSuccess: () => {
            toast.success("Bookmark created successfully");
            queryClient.invalidateQueries({ queryKey: ["bookmark_links"] });
        },
        onError: (error) => {
            toast.error(error.message);
            console.error(error.message);
        },
    });
}